﻿import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionService } from '../services/session.service';

@Injectable()
export class LanguageLoader implements TranslateLoader {

    constructor(
        private http: HttpClient,
        private sessionService: SessionService
    ) { }

    getTranslation(lang: string): Observable<any> {
        if (this.sessionService.getClientId() && this.sessionService.getClientId() > 1) {
            return this.http.get('/assets/translate/' + this.sessionService.getClientId() + '/' + lang + '.json')
                .pipe(catchError((response: Response) => this.http.get('/assets/translate/' + lang + '.json')
                    .pipe(catchError((response2: Response) => this.http.get('/assets/translate/es.json')))));
        }
        return this.http.get('/assets/translate/' + lang + '.json')
            .pipe(catchError((response2: Response) => this.http.get('/assets/translate/es.json')));
    }
}
